import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { Icon } from '@calendly/ui/components/icon';
import classNames from 'classnames';
import { debounce } from 'lodash-es';
import PropTypes from 'prop-types';
import { PureComponent, forwardRef } from 'react';
import { isEnterKey } from 'services/keycodes';
const searchInputWrapperCss = "s1novyij";
const SearchInputWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(searchInputWrapperCss, props.className)} />;
});
const styledInputCss = "s77d1st";
const StyledInput = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'input';
  return <Component ref={ref} {...restProps} className={classNames(styledInputCss, props.className)} />;
});
const rightAlignedButtonCss = "rjkb80f";
const RightAlignedButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(rightAlignedButtonCss, props.className)} />);
const magnifyingGlassIconCss = "m7icuea";
const MagnifyingGlassIcon = forwardRef((props, ref) => {
  const name = 'magnifying-glass';
  return <Icon ref={ref} {...props} name={name} className={classNames(magnifyingGlassIconCss, props.className)} />;
});
export default class SearchInput extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
    autoFocus: PropTypes.bool,
    debounceTimeout: PropTypes.number,
    initialValue: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func
  };
  static defaultProps = {
    autoFocus: false,
    initialValue: '',
    className: '',
    debounceTimeout: 500,
    placeholder: '',
    disabled: false,
    onFocus: () => {},
    onBlur: () => {}
  };
  constructor(props) {
    super(props);
    this.state = {
      value: props.initialValue
    };
    this.debouncedOnChange = debounce(props.onChange, props.debounceTimeout);
  }
  componentDidMount() {
    this.debouncedOnChange = debounce(this.props.onChange, this.props.debounceTimeout);
    this.setState({
      value: this.props.initialValue
    });
  }
  checkEnter = event => {
    if (isEnterKey(event)) {
      this.debouncedOnChange.cancel();
      this.props.onChange(this.state.value);
    }
  };
  updateValue = event => {
    const value = event.target.value || '';
    this.setState({
      value
    });
    this.debouncedOnChange(value);
  };
  clearValue = () => {
    const value = '';
    this.debouncedOnChange.cancel();
    this.setState({
      value
    });
    return this.props.onChange(value);
  };

  // ################################################################

  render() {
    return <SearchInputWrapper className={this.getClassName()}>
        {this.renderSearchButton()}
        {this.renderClearButton()}
        <StyledInput value={this.state.value} name="filter-term" placeholder={this.props.placeholder} autoComplete="off" autoFocus={this.props.autoFocus} disabled={this.props.disabled} onKeyUp={this.checkEnter} onChange={this.updateValue} onFocus={this.props.onFocus} onBlur={this.props.onBlur} />
      </SearchInputWrapper>;
  }
  renderSearchButton() {
    if (this.isFiltering()) {
      return null;
    }
    return <MagnifyingGlassIcon />;
  }
  renderClearButton() {
    if (!this.isFiltering()) {
      return null;
    }
    return <RightAlignedButton aria-label={I18n.t('publisher.action.clear')} onClick={this.clearValue}>
        <Icon name="delete" />
      </RightAlignedButton>;
  }

  // ################################################################

  isFiltering() {
    return this.state.value.length > 0;
  }
  getClassName() {
    return classNames('search-input', this.props.className);
  }
}

require("./index.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.js");